import { render, staticRenderFns } from "./AccountLogo.vue?vue&type=template&id=74b76d9a&scoped=true"
var script = {}
import style0 from "./AccountLogo.vue?vue&type=style&index=0&id=74b76d9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b76d9a",
  null
  
)

export default component.exports